var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"white-space":"pre-line"}},[(_vm.component.length > 0)?_c(_vm.component,{tag:"component",attrs:{"payload":_vm.componentPayload},on:{"input":_vm.onPropsPass}}):_c('div',[(!_vm.isBlank)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.$sanitize(this.alert.content))}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }